import React from 'react';
import { Users, Sparkles, Scissors } from 'lucide-react';

const ITEMS = [
  { icon: Users, title: 'Native-owned & designed', text: 'Developed by Finest Feathers, an Indigenous-owned California business, so every roll supports Native creators.' },
  { icon: Sparkles, title: 'Basket-inspired patterns', text: 'Distinctive designs drawn from the artistry of California Native basketry, printed on smooth satin.' },
  { icon: Scissors, title: 'Ready for your project', text: 'Ten yards per roll in two widths, enough for ribbon skirts, shirts, regalia accents and gifts.' },
];

export const RibbonWhy = () => (
  <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28" data-testid="ribbon-why">
    <p className="rb-eyebrow mb-4">Why our ribbon</p>
    <h2 className="rb-head text-5xl sm:text-6xl lg:text-7xl mb-14 max-w-3xl">
      <span className="rb-neon">More than ribbon.</span> <span className="rb-grad">A story in every yard.</span>
    </h2>
    <div className="grid md:grid-cols-3 gap-5">
      {ITEMS.map((it, i) => (
        <div key={it.title} data-testid={`why-card-${i}`} className="rb-glass rb-glass-hover rounded-3xl p-8">
          <div className="w-14 h-14 rounded-2xl rb-btn flex items-center justify-center mb-6">
            <it.icon className="w-7 h-7 text-white" />
          </div>
          <h3 className="rb-head text-2xl text-white mb-3">{it.title}</h3>
          <p className="text-white/65 leading-relaxed">{it.text}</p>
        </div>
      ))}
    </div>
  </section>
);
